import React, { Component } from "react";
import { connect } from "react-redux";
import { hashHistory } from "react-router";
import './nheader.css'

class NHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  goBack = () => {
    hashHistory.goBack();
  };

  render() {
    return (
      <div className="NHeader_container">
        <div className="NHeader_wrap">         
          <div className="NHeader_content">
            <div className="NHeader_goback" onClick={this.goBack}><img src={require('../img/n_icon_goback@2x.png')} /></div>
            <div className="NHeader_title">{this.props.title}</div>
            <div className="NHeader_share">
              {this.props.rightContent}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    SupperFundHome: state.SupperFundHome,
  };
}
export default connect(mapStateToProps)(NHeader);



// WEBPACK FOOTER //
// ./src/components/NHeader.js